export const Chevron = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        d="M7.783 14.365a.5.5 0 0 1-.023-.707L11.19 10 7.76 6.342a.5.5 0 0 1 .73-.684l3.75 4a.5.5 0 0 1 0 .684l-3.75 4a.5.5 0 0 1-.707.023Z"
      />
    </svg>
  )
}
